import React, { useEffect, useState } from "react";
import { Divider, Row, Col, Radio, Checkbox, message, Image } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";

const StepRegItemWidget = (props) => {
  const { itemInfo, onCheck, isLast, camperIndex, userData } = props;

  const toAbsoluteUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    const base = process.env.REACT_APP_API?.replace("/api/", "") || "";
    const cleanPath = url.startsWith("/") ? url.slice(1) : url;
    return `${base}/${cleanPath}`;
  };

  const imageUrl = toAbsoluteUrl(itemInfo?.image_url);

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontWeight: 600 }}>
        <div style={{ marginTop: 10, marginBottom: 5 }}>
          <Row align={"top"} justify="space-between" gutter={[16, 4]}>
            <Col md={13}>
              <Checkbox
                disabled={itemInfo.open == "0"}
                onChange={(e) => {
                  if (onCheck != undefined) {
                    onCheck(camperIndex, itemInfo.ID);
                  }
                }}
                checked={userData.camperInfo[camperIndex].sel_reg_id.some(t => t.id === itemInfo.ID)}
              >
                {itemInfo.registration_text.split("\\n").map((section, secKey) => {
                  return <div key={secKey}>{section}</div>;
                })}
              </Checkbox>
            </Col>
            {imageUrl && (
              <Col md={2} style={{ display: "flex", justifyContent: "center" }}>
                <Image
                  width={48}
                  height={36}
                  src={imageUrl}
                  preview={{
                    mask: (
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <EyeOutlined />
                        <span style={{ fontSize: 12 }}>View</span>
                      </div>
                    ),
                  }}
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                />
              </Col>
            )}
            <Col
              md={4}
              style={{ textAlign: "right", marginLeft: 25 }}
            >
              ${parseFloat(itemInfo.registration_fee).toFixed(2)}
            </Col>
            <Col
              md={5}
              style={{ textAlign: "right", marginRight: 25 }
              }
            >
              Remaining - {parseInt(itemInfo.max_registrations) - parseInt(itemInfo.current_registrations)}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default StepRegItemWidget;
